import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/logo.png'

const NotFound = () => {
    return (
        <div style={{ minHeight: '100vh' }} className=' bg-brand'>
            <div className="d-flex justify-content-center align-items-center pt-3">
                <img className='img-fluid' src={logo} alt="vehicle" />
                <h1 style={{ lineHeight: '50px' }} className='fw-bold mt-2'>eTracker</h1>
            </div>

            <div style={{ minHeight: '600px' }} className="d-flex justify-content-center align-items-center">
                <div className="container">
                    <h1 className='h1 text-brand-danger text-center fw-bold'>404 <br /> Not Found</h1>
                    <Link to='/' className='text-decoration-none'><button className='btn btn-sm btn-primary mx-auto d-block'>Go Home</button></Link>
                </div>
            </div>
        </div>
    );
};

export default NotFound;